"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function SuiIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "m12.607,1.748c-.32-.326-.895-.326-1.215,0-.793.809-7.746,8.029-7.746,12.395,0,4.606,3.747,8.354,8.354,8.354s8.354-3.747,8.354-8.354c0-4.365-6.953-11.586-7.746-12.395Zm-7.262,12.395c0-1.351.992-3.253,2.275-5.141.254,3.168,2.113,4.411,3.785,5.493,1.743,1.128,3.394,2.201,3.615,5.569-.908.465-1.933.733-3.021.733-3.669,0-6.654-2.985-6.654-6.654Zm11.254,4.797c-.55-3.453-2.584-4.78-4.27-5.871-1.71-1.106-3.061-1.98-3.061-4.786,0-.935.34-1.737.614-2.282.769-.937,1.514-1.778,2.117-2.426,2.301,2.471,6.654,7.732,6.654,10.568,0,1.884-.791,3.585-2.054,4.797Z" })));
}
exports.default = SuiIcon;
